import { useState } from 'react';
import { Input } from '../../shared/ui/Input/Input';
import { apiRequests } from '../../shared/api/apiRequests';
import { Select } from '../../shared/ui/Select/ui/Select';
import { USER_ROLES } from '../../Pages/Roles';
import { toast, ToastContainer } from 'react-toastify';
import { AccessTypeOfUser } from '../../features/AccessTypeOfUser/AccessTypeOfUser.jsx';

export const CreateUserForm = () => {
  // Используем единый объект формы с вложенным RoleModel
  const [form, setForm] = useState({
    name: '',
    surname: '',
    patronymic: '',
    email: '',
    phone: '',
    password: '',
    countryId: 1,
    roleModel: {
      role: 2,
      isAllCountriesAccess: true,
      availableCountriesIds: [],
      forbiddenCountriesIds: [],
      reviewsAccess: { accessLevel: 0 },
      hrAccess: { accessLevel: 0 },
      shopAccess: { accessLevel: 0 },
      outstaffAccess: { accessLevel: 0 },
      contentAccessTypes: []
    }
  });
  
  // Состояние для управления доступами пользователя (используется только для компонента AccessTypeOfUser)
  const [access, setAccess] = useState({
    isAllCountriesAccess: true,
    availableCountries: [],
    forbiddenCountries: [],
    reviewsAccess: { accessLevel: 0 },
    hrAccess: { accessLevel: 0 },
    shopAccess: { accessLevel: 0 },
    outstaffAccess: { accessLevel: 0 },
    contentAccessTypes: []
  });

  // Функция для синхронизации данных между компонентом AccessTypeOfUser и формой
  const syncAccessToRoleModel = () => {
    setForm(prev => ({
      ...prev,
      roleModel: {
        ...prev.roleModel,
        // Используем имена полей в формате PascalCase для API
        Role: access.role || access.Role,
        IsAllCountriesAccess: access.isAllCountriesAccess || access.IsAllCountriesAccess,
        AvailableCountriesIds: access.availableCountries || access.AvailableCountriesIds || [],
        ForbiddenCountriesIds: access.forbiddenCountries || access.ForbiddenCountriesIds || [],
        ReviewsAccess: access.reviewsAccess || access.ReviewsAccess,
        HRAccess: access.hrAccess || access.HRAccess,
        ShopAccess: access.shopAccess || access.ShopAccess,
        OutstaffAccess: access.outstaffAccess || access.OutstaffAccess,
        ContentAccessTypes: access.contentAccessTypes || access.ContentAccessTypes || []
      }
    }));
  };

  const handleSubmit = async () => {
    try {
      // Синхронизуем данные доступа с RoleModel перед отправкой
      syncAccessToRoleModel();
      
      // Создаем пользователя с включенным RoleModel
      await apiRequests.users.create(form);
      
      toast.success('Пользователь успешно создан');
      
      // Очищаем форму после успешного создания
      setForm({
        name: '',
        surname: '',
        phone: '',
        email: '',
        password: '',
        roleModel: {
          role: 2, // По умолчанию роль Администратор
          isAllCountriesAccess: true,
          availableCountriesIds: [],
          forbiddenCountriesIds: [],
          reviewsAccess: { accessLevel: 0 },
          hrAccess: { accessLevel: 0 },
          shopAccess: { accessLevel: 0 },
          outstaffAccess: { accessLevel: 0 },
          contentAccessTypes: []
        }
      });
      
      // Сбрасываем состояние доступов
      setAccess({
        role: 2,
        isAllCountriesAccess: true,
        availableCountries: [],
        forbiddenCountries: [],
        reviewsAccess: { accessLevel: 0 },
        hrAccess: { accessLevel: 0 },
        shopAccess: { accessLevel: 0 },
        outstaffAccess: { accessLevel: 0 },
        contentAccessTypes: []
      });
      
    } catch (error) {
      console.error('Error creating user:', error);
      toast.error('Произошла ошибка при создании пользователя');
    }
  };

  return (
    <div>
      <div className="page-content mb-3">
        <div className="mb-3">
          <Input
            value={form?.name || ''}
            onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
            label={'Имя'}
            placeholder={'Иван'}
          />
        </div>

        <div className="mb-3">
          <Input
            value={form?.surname || ''}
            onChange={(e) => setForm((prev) => ({ ...prev, surname: e.target.value }))}
            label={'Фамилия'}
            placeholder={'Иванов'}
          />
        </div>

        <div className="mb-3">
          <Input
            value={form?.phone || ''}
            onChange={(e) => setForm((prev) => ({ ...prev, phone: e.target.value }))}
            label={'Телефон'}
            placeholder={'Телефон'}
          />
        </div>

        <div className="mb-3">
          <Input
            value={form?.email || ''}
            onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
            label={'E-mail'}
            placeholder={'Email'}
          />
        </div>

        <div className="mb-3">
          <Input
            value={form?.password || ''}
            onChange={(e) => setForm((prev) => ({ ...prev, password: e.target.value }))}
            label={'Пароль'}
            placeholder={'Пароль'}
          />
        </div>
        {/* Выбор роли перенесен в блок доступов */}
      </div>

      <div className="page-content mb-3">
        <h5>Доступы</h5>
        <AccessTypeOfUser
          initialData={access}
          userId={null} // userId будет null при создании пользователя
          setData={setAccess}
        />
      </div>
      
      <div className="button-content button-right">
        <a onClick={handleSubmit} className="at-btn at-btn-medium">
          Создать
        </a>
      </div>
      <ToastContainer />
    </div>
  );
};
